import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbSelectModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { StateService } from '../../@core/utils/state.service';
import { ApiService } from '../../services/api/api.service';

@Component({
  selector: 'select-principal',
  standalone: true,
  imports: [CommonModule, FormsModule, NbSelectModule, TranslateModule],
  template: `
    <nb-select
      *ngIf="visible"
      [ngModel]="state.selectedPrincipalId$()"
      (selectedChange)="state.setSelectedPrincipal($event)"
      [ngModelOptions]="{ standalone: true }"
      [placeholder]="'patientInvite.selectDoctor' | translate"
      [status]="state.selectedPrincipalId$() ? 'success' : 'danger'"
      fullWidth>
      <nb-option *ngFor="let p of state.allowedPrincipals$()" [value]="p.documentId">
        Dr. {{ p.firstName }} {{ p.lastName }}
      </nb-option>
    </nb-select>
  `,
})
export class SelectPrincipalComponent implements OnInit {
  /** Show even when only one principal is available. */
  @Input() alwaysShow = false;

  constructor(public state: StateService, private api: ApiService) {}

  ngOnInit(): void {
    void this.state.loadAllowedPrincipals(this.api);
  }

  get visible(): boolean {
    const n = this.state.allowedPrincipals$().length;
    return this.alwaysShow ? n > 0 : n > 1;
  }
}